import generateHandleActions from 'redux/state-handler';
import {
  LIST_BRANDS,
  LIST_FAQS,
  LIST_FEATURES,
  LIST_GLOBALS,
  LIST_PACKS,
  LIST_PERMISSIONS,
  LIST_ROLES,
  LIST_TAGS,
  LIST_TEAM_MEMBERS,
  LIST_TUTORIALS,
  LIST_UOMS,
  LIST_HOME_SECTIONS,
  LIST_ABOUT_PAGE,
} from 'redux/constants';

const apiStates = [
  { type: LIST_BRANDS, name: 'brands' },
  { type: LIST_FAQS, name: 'faqs' },
  { type: LIST_FEATURES, name: 'features' },
  { type: LIST_GLOBALS, name: 'globals' },
  { type: LIST_PACKS, name: 'packs' },
  { type: LIST_PERMISSIONS, name: 'permissions' },
  { type: LIST_ROLES, name: 'roles' },
  { type: LIST_TAGS, name: 'tags' },
  { type: LIST_TEAM_MEMBERS, name: 'teamMembers' },
  { type: LIST_TUTORIALS, name: 'tutorials' },
  { type: LIST_UOMS, name: 'uoms' },
  { type: LIST_HOME_SECTIONS, name: 'homeSections' },
  { type: LIST_ABOUT_PAGE, name: 'aboutPage' },
];
const instantStates = [];
const storage = {};
const listValues = [
  'brands',
  'faqs',
  'features',
  'globals',
  'packs',
  'permissions',
  'roles',
  'tags',
  'teamMembers',
  'tutorials',
  'uoms',
  'homeSections',
  'aboutPage',
];

export default generateHandleActions({ apiStates, instantStates, storage, listValues });
